import React from 'react';
import ProductDetailAction from './ProductDetailAction';

const ProductDetailTextSection = ({ productDetail }) => {
    if (!productDetail) {
        return <div>Loading...</div>;
    }

    return (
        <div className="fz-product-details__txt">

            <h2 className="fz-product-details__title">{productDetail.name}</h2>


            <div className="fz-product-details__price-rating">
                <span className="price">
                    {productDetail.price.toLocaleString('en-US')} vnđ
                </span>
                <div className="rating">
                    {Array.from({ length: 5 }).map((_, index) => (
                        <i
                            key={index}
                            className={
                                index < productDetail.avgStar
                                    ? "fa-solid fa-star"
                                    : "fa-solid fa-star"
                            }
                        ></i>
                    ))}
                </div>
            </div>


            <div className="fz-product-details__infos">
                <ul>

                    <li>
                        <span className="info-property"> Loại </span> :{" "}
                        <span className="info-value">Paypal</span>
                    </li>
                    <li>
                        <span className="info-property"> Kho </span> :{" "}
                        <span className="info-value">
                            Còn <span style={{ fontWeight: 'bold' }}>{productDetail.stock}</span> sản phẩm
                        </span>
                    </li>

                    <li>
                        <span className="info-property"> Mô tả </span> :{" "}
                        <span className="info-value">
                        {productDetail.description || "No description available."}
                        </span>
                    </li>
                </ul>
            </div>


            {/* <p className="fz-product-details__short-descr">
                {productDetail.description || "No description available."}
            </p> */}


            <div>

                <ProductDetailAction productDetail={productDetail} />

            </div>

        </div>
    );
};

export default ProductDetailTextSection;
